import { useSyncExternalStore } from 'react';
import { dismissToast, getSnapshot, subscribe } from './toastStore';

/**
 * Renders active toasts in a polite live region (spec §16). Mounted once at the
 * app root.
 */
export function ToastViewport() {
  const toasts = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  if (toasts.length === 0) return null;
  return (
    <div className="toast-viewport" role="region" aria-label="Thông báo" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast--${toast.tone}`}>
          <span>{toast.message}</span>
          <button
            type="button"
            className="toast__close"
            aria-label="Đóng thông báo"
            onClick={() => dismissToast(toast.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
